<nav class="dev-nav">
  <span class="dev-nav-tag">dev</span>
  <div class="dev-nav-tabs">
    @for (tab of tabs; track tab.path) {
      <a
        class="dev-tab"
        [routerLink]="tab.path"
        routerLinkActive="active"
        queryParamsHandling="preserve">
        {{ tab.label }}
      </a>
    }
  </div>
  <div class="dev-nav-right">
    <span class="dev-nav-user" [title]="userLabel">{{ userLabel }}</span>
    <button type="button" class="dev-nav-reset" (click)="resetAuth()" title="Vide le token et le cache local, puis retourne au login">
      Réinit. token
    </button>
  </div>
</nav>
